module.exports = __webpack_public_path__ + "static/img/3.dc5e4ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/3.png
// module id = +Yeu
// module chunks = 0